<svg slot="open-indicator" width="1em" viewBox="0 0 448 512" aria-hidden="true">
    <use xlink:href="@Assets/svg/symbol-defs.svg#arrow-down"/>
</svg>
